import { arrayIsNotEmpty, isPresent, stringIsPresent } from "../utils/checks";
import { BlockContentValue } from "./UnstyledBlockContent";

export const isBlockContentValuePresent = (
  x: BlockContentValue
): x is NonNullable<BlockContentValue> => {
  if (!isPresent(x)) return false;
  if (Array.isArray(x)) return arrayIsNotEmpty(x);
  if (typeof x == "string") return stringIsPresent(x);
  return true;
};
